export const socialContact = [
    {
      icon: <i className="fab fa-instagram"></i>,
      value: <a href="https://www.instagram.com/vodelinasamatova/">@vodelinasamatova</a>
    }
];